// Plataforma interna (Andrés y Rocío). Mismo código en dos modos (ver main.tsx y README):
//   VITE_MODO=demo      → datos de prueba de §E en el navegador (sin backend)
//   VITE_MODO=supabase  → el proyecto Supabase de ESTA instalación
import type { AuthProvider } from "ra-core";
import { CRM } from "@/components/atomic-crm/root/CRM";
import { configuracionAgencia } from "@/reclutamiento/configuracion";
import { MODO, NOMBRE_INSTALACION } from "@/reclutamiento/modo";
import "@/interna/interna.css";

const App = ({ dataProvider, authProvider }: { dataProvider: any; authProvider: AuthProvider }) => (
  <CRM
    {...configuracionAgencia}
    title={MODO === "demo" ? `${NOMBRE_INSTALACION} · demo` : NOMBRE_INSTALACION}
    dataProvider={dataProvider}
    authProvider={authProvider}
    disableTelemetry
  />
);

export default App;
